// extracted by mini-css-extract-plugin
export default {"content":"shared-styles_content__NZU8U","smartFormatToggle":"shared-styles_smartFormatToggle__1vOmO"};